import { call } from '../core'
import { IAccountInfoResult } from './getMyAccount'

export interface IWithdrawalAccountParams {
  title?: string
  selectedAccountNo?: string
  depositAccountNo?: string
  amount: string
}

export function getWithdrawalAccount(
  params: IWithdrawalAccountParams,
): Promise<IAccountInfoResult | Error> {
  return call('finGetWithdrawalAccount', params)
}
